import { render, staticRenderFns } from "./radio-text.vue?vue&type=template&id=1f0f2b2e"
import script from "./radio-text.vue?vue&type=script&lang=ts"
export * from "./radio-text.vue?vue&type=script&lang=ts"
import style0 from "./radio-text.vue?vue&type=style&index=0&id=1f0f2b2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports